// Asks the server whether a stranger can open a Figma prototype. See
// api/_lib/figmaLinkCheck.js. Always resolves: 'viewable', 'not_viewable' or 'unknown'.
// Anything that goes wrong is 'unknown', and the screen shows nothing for it.
import { auth } from '../firebase';

export async function requestLinkCheck(key) {
  try {
    const user = auth.currentUser;
    if (!user || !key) return 'unknown';
    const idToken = await user.getIdToken();
    const res = await fetch('/api/figma-link-check', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
      body: JSON.stringify({ key }),
    });
    if (!res.ok) return 'unknown';
    const data = await res.json();
    return data && (data.status === 'viewable' || data.status === 'not_viewable') ? data.status : 'unknown';
  } catch (e) {
    return 'unknown';
  }
}
